import type { LeadDetail } from '../api/crm';
import './crm-affiliate-flow.css';

function fmt(s: string | null | undefined): string {
  if (!s) return '';
  const d = new Date(s);
  return Number.isNaN(d.getTime())
    ? ''
    : d.toLocaleString('cs-CZ', { day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

type ChipState = 'ok' | 'wait' | 'bad' | 'none';

function Chip({ state, label, at }: { state: ChipState; label: string; at?: string | null }) {
  return (
    <span className={`crm-mail-chip is-${state}`}>
      <b aria-hidden="true">{state === 'ok' ? '✓' : state === 'bad' ? '!' : '·'}</b>
      <span>{label}</span>
      {at ? <small>{fmt(at)}</small> : null}
    </span>
  );
}

function MailRow({
  title,
  hint,
  sentAt,
  openedAt,
  clickedAt,
  bouncedAt,
  clickLabel,
  unknownSent,
}: {
  title: string;
  hint: string;
  sentAt: string | null;
  openedAt: string | null;
  clickedAt: string | null;
  bouncedAt: string | null;
  clickLabel: string;
  unknownSent?: boolean;
}) {
  const sent = !!sentAt || unknownSent;
  return (
    <div className="crm-mail-row">
      <div className="crm-mail-name"><strong>{title}</strong><small>{hint}</small></div>
      <div className="crm-mail-chips">
        {bouncedAt ? (
          <Chip state="bad" label="Nedoručeno" at={bouncedAt} />
        ) : (
          <Chip state={sent ? 'ok' : 'none'} label={sent ? 'Odesláno' : 'Neodesláno'} at={sentAt} />
        )}
        <Chip state={openedAt ? 'ok' : sent && !bouncedAt ? 'wait' : 'none'} label={openedAt ? 'Otevřeno' : 'Neotevřeno'} at={openedAt} />
        <Chip state={clickedAt ? 'ok' : sent && !bouncedAt ? 'wait' : 'none'} label={clickedAt ? clickLabel : 'Bez prokliku'} at={clickedAt} />
      </div>
    </div>
  );
}

export function CrmLeadMails({ lead, showRegistration }: { lead: LeadDetail; showRegistration: boolean }) {
  return (
    <section className="crm-mails" aria-label="Servisní e-maily">
      <header className="crm-aflow-head">
        <span className="crm-detail-eyebrow">Servisní e-maily</span>
        {!lead.email && <span className="crm-aflow-count">Lead nemá e-mail</span>}
      </header>
      <MailRow
        title="Double opt-in"
        hint="Potvrzení e-mailu po odeslání formuláře"
        sentAt={lead.doiSentAt}
        openedAt={lead.doiOpenedAt}
        clickedAt={lead.confirmedAt}
        bouncedAt={lead.doiBouncedAt}
        clickLabel="Potvrzeno"
        unknownSent={!lead.doiSentAt && !!lead.confirmedAt}
      />
      {showRegistration && (
        <MailRow
          title="Registrace do affiliate platformy"
          hint="Odkaz na registraci po schválení zájemce"
          sentAt={lead.registrationSentAt}
          openedAt={lead.registrationOpenedAt}
          clickedAt={lead.registrationClickedAt}
          bouncedAt={lead.registrationBouncedAt}
          clickLabel="Proklik"
        />
      )}
    </section>
  );
}
